import { forwardRef } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { FormikError } from '../formik_error/FormikError'
import styles from './CheckBox.module.scss'

export const CheckBox = forwardRef(
  (
    {
      checked,
      onChange,
      formik,
      field,
      label,
      classes = {},
      ariaLabel,
      square = false,
      isRequired = false,
      tabIndex,
      onFocus,
      onKeyDown,
      role = 'checkbox',
    }: any,
    ref: any,
  ) => {
    const { t } = useTranslation()

    return (
      <div
        className={styles['checkboxWrapper']}
        role={role}
        ref={ref}
        aria-checked={checked}
        tabIndex={tabIndex || 0}
        onFocus={onFocus}
        aria-label={`${ariaLabel || label}: ${checked ? t('registration.selected') : t('registration.unSelected')}`}
        onClick={() => onChange(!checked)}
        onKeyDown={
          !onKeyDown
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onChange(!checked)
                }
              }
            : onKeyDown
        }
      >
        <div className={clsx(styles['btn'], classes.container)}>
          <div
            className={clsx(styles['btn__toggle'], {
              [styles['btn__toggle--active']]: checked,
              [styles['btn__toggle--square']]: square,
            })}
          />

          {label && (
            <span className={clsx(styles['btn__label'], classes.content)}>
              {label} {isRequired && <span className={styles['btn__label--required']}>*</span>}
            </span>
          )}
        </div>

        {formik && <FormikError formik={formik} fieldName={field} />}
      </div>
    )
  },
)

CheckBox.displayName = 'CheckBox'
